import type { SourceSnippet } from '@/types/source-snippet'

export interface SourceToolResult {
  snippet?: SourceSnippet
  evidence_reference_id?: string
  count?: number
  results?: SourceToolResult[]
  error?: string
  coverage?: { complete: boolean }
}

export function parseSourceToolResult(result: SourceToolResult | string | undefined) {
  if (typeof result !== 'string') return result ?? null
  try {
    return JSON.parse(result) as SourceToolResult
  } catch {
    return null
  }
}

export function resultSnippets(result: SourceToolResult | null): SourceSnippet[] {
  if (!result) return []
  return result.snippet ? [result.snippet] : (result.results ?? []).flatMap(resultSnippets)
}

export function mappedEntityTypes(snippet: SourceSnippet): string[] {
  const types = snippet.snapshot.inputs.flatMap(({ interpretation }) => {
    if (interpretation.status !== 'confirmed' || !interpretation.recipe) return []
    return ['subject_entities', 'entity_descriptors'].flatMap(key => {
      const descriptors = interpretation.recipe?.[key]
      if (!Array.isArray(descriptors)) return []
      return descriptors.flatMap((descriptor: unknown) => {
        if (!descriptor || typeof descriptor !== 'object' || !('schema_type' in descriptor))
          return []
        return typeof descriptor.schema_type === 'string' ? [descriptor.schema_type] : []
      })
    })
  })
  return [...new Set(types)]
}
